import { render, staticRenderFns } from "./StudentLeyend.vue?vue&type=template&id=746eae92&scoped=true"
import script from "./StudentLeyend.vue?vue&type=script&lang=js"
export * from "./StudentLeyend.vue?vue&type=script&lang=js"
import style0 from "./StudentLeyend.vue?vue&type=style&index=0&id=746eae92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746eae92",
  null
  
)

export default component.exports